// The area under an order's pin (order.pinArea, set by the server in cities
// whose areas are drawn on the map) is not the one the order carries — trial
// mode's mismatch, or an order that came in without an area in «Αυτόματα».
// null / undefined means the pin was never checked.
export const pinAreaDiffers = order =>
	order?.pinArea !== null && order?.pinArea !== undefined && order.pinArea !== (order.area || '');

export const pinAreaLabel = order =>
	order?.pinArea ? `Στίγμα: ${order.pinArea}` : 'Στίγμα εκτός περιοχών';
